// extracted by mini-css-extract-plugin
module.exports = {"notificationRow":"notification_notificationRow__2bmGO","imageWrapper":"notification_imageWrapper__hyTBd"};